namespace Matrix.Data {
    export interface JpmSecClassResultForm {
        SecurityId: Serenity.StringEditor;
        SecTypeCode: Serenity.StringEditor;
        Industry: Serenity.StringEditor;
        DaysToMaturity: Serenity.StringEditor;
        MaturityBand: Serenity.StringEditor;
        CountryOfExposure: Serenity.StringEditor;
        CurrencyOfExposure: Serenity.StringEditor;
        EmergingMarket: Serenity.StringEditor;
        AaSector: Serenity.StringEditor;
        CounterpartyOrIssuer: Serenity.StringEditor;
        CountryOfIssue: Serenity.StringEditor;
    }

    export class JpmSecClassResultForm extends Serenity.PrefixedContext {
        static formKey = 'Data.JpmSecClassResult';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!JpmSecClassResultForm.init)  {
                JpmSecClassResultForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;

                Q.initFormType(JpmSecClassResultForm, [
                    'SecurityId', w0,
                    'SecTypeCode', w0,
                    'Industry', w0,
                    'DaysToMaturity', w0,
                    'MaturityBand', w0,
                    'CountryOfExposure', w0,
                    'CurrencyOfExposure', w0,
                    'EmergingMarket', w0,
                    'AaSector', w0,
                    'CounterpartyOrIssuer', w0,
                    'CountryOfIssue', w0
                ]);
            }
        }
    }
}
